export const V2_BOOKING_STEPS = ['availability', 'extras'] as const;

export type BookingEntity = 'treatment' | 'facility' | 'spaDay';

export const LEGACY_BOOKING_STEPS: Record<BookingEntity, Record<string, string>> = {
  treatment: {
    treatmentAvailabilityStep: 'availability',
    customiseTreatmentStep: 'extras',
    guestDetailsStep: 'availability',
  },
  facility: {
    facilityAvailabilityStep: 'availability',
    customisFacilityStep: 'extras',
    guestDetailsStep: 'availability',
  },
  spaDay: {},
};

export const canonicalBookingStep = (
  step: string | string[] | undefined,
  entity: BookingEntity
): string | undefined => {
  const raw = Array.isArray(step) ? step[0] : step;
  if (!raw) return undefined;
  if ((V2_BOOKING_STEPS as readonly string[]).includes(raw)) return raw;
  return LEGACY_BOOKING_STEPS[entity][raw];
};
